<template>
  <div class="row mb-10">
    <div class="col-12">
      <EducationHierarchySelect
        @setParameters="parameters = $event"
      />
    </div>
    <div class="col-sm-12 col-md-6 d-flex align-center">
      <v-select
        v-model="type"
        :items="types"
        item-text="typeName"
        item-value="value"
        label="Tipo"
      >
        <template
          v-if="type !== null"
          #append
        >
          <v-btn
            color="primary"
            text
            @click="type = null"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-select>
    </div>
    <div class="col-sm-12 col-md-6 d-flex align-center justify-end">
      <v-btn
        depressed
        :disabled="hasParameters"
        class="float-right"
        @click="setParameters()"
      >
        <v-icon left>
          mdi-magnify
        </v-icon>
        Aplicar filtros
      </v-btn>
    </div>
  </div>
</template>

<script>
import EducationHierarchySelect from '@/components/contents/EducationHierarchySelect.vue'

export default {
  components: {
    EducationHierarchySelect
  },

  data: () => ({
    type: null,
    types: [
      { typeName: 'Video Aula', value: 1 },
      { typeName: 'Questão Comentada', value: 2 },
      { typeName: 'Podcast', value: 3 },
      { typeName: 'AudioBook', value: 4 },
      { typeName: 'Bizu', value: 5 }
    ],
    parameters: {}
  }),
  watch: {
    type (newValue) {
      this.parameters.push(this.type)
    }
  },
  computed: {
    hasParameters () {
      return Object.entries(this.parameters).filter(([_, value]) => value !== null).length === 0 && this.type === null
    }
  },

  async created () {
  },

  methods: {
    setParameters () {
      if (this.type !== null) {
        this.parameters.type = this.type
      } else {
        delete this.parameters.type
      }
      const parameters = this.buildQuery()
      this.$emit('setParameters', parameters)
    },

    buildQuery () {
      return Object.entries(this.parameters)
        .filter(([_, value]) => value !== null)
        .map(
          ([key, value]) =>
            `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('')
    }
  }
}
</script>
